import { useFavorites } from '@/hooks/useFavorites';
import { useToast } from '@/components/base/Toast';

interface ActionButtonsProps {
  id: string;
  title: string;
}

export default function ActionButtons({ id, title }: ActionButtonsProps) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const { showToast } = useToast();
  const favorited = isFavorite(id);

  const handleFavorite = () => {
    const next = toggleFavorite(id);
    showToast(next ? '已加入我的收藏' : '已取消收藏');
  };

  const handleShare = async () => {
    const shareUrl = window.location.href;
    try {
      if (navigator.share) {
        await navigator.share({ title, url: shareUrl });
        return;
      }
      await navigator.clipboard.writeText(shareUrl);
      showToast('链接已复制到剪贴板');
    } catch {
      showToast('分享失败，请手动复制地址栏链接');
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-3">
      <button
        type="button"
        onClick={handleFavorite}
        className={`inline-flex items-center gap-2 whitespace-nowrap rounded-md px-5 py-2.5 text-sm font-semibold transition-colors ${
          favorited
            ? 'bg-accent-500 text-accent-950 hover:bg-accent-400'
            : 'border border-background-300 bg-background-50 text-foreground-700 hover:bg-background-100'
        }`}
      >
        <i className={favorited ? 'ri-heart-fill' : 'ri-heart-line'}></i>
        {favorited ? '已收藏' : '收藏'}
      </button>
      <button
        type="button"
        onClick={handleShare}
        className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-semibold text-foreground-700 transition-colors hover:bg-background-100"
      >
        <i className="ri-share-line"></i>
        分享
      </button>
    </div>
  );
}